/* sp-nav2.js – Navigation V2: Umschalter Bedrucken|Besticken (Desktop + Mobil), zweite Ebene im Mobil-Drawer, Filter (Suche, A–Z) im Layout C,
   Produkt-Treffer der Textilien-Suche (Predictive Search, snippets/sp-nav2-presults.liquid),
   Board 266: Jacken-Akkordeon mobil + Branchenband „Handwerk & Bau“. Vorstand: assets/sp-nav2-vor-266.js */
(function () {
  'use strict';
  function tabs(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-spn2-tab-btn]');
      if (!b || !root.contains(b)) return;
      var box = b.closest('[data-spn2-tabs]'), key = b.getAttribute('data-spn2-tab-btn');
      if (!box) return;
      e.preventDefault();
      box.querySelectorAll('[data-spn2-tab-btn]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      box.querySelectorAll('[data-spn2-tab]').forEach(function (p) { p.hidden = p.getAttribute('data-spn2-tab') !== key; });
    });
  }
  /* Layout C: Suche filtert die Listen im Panel, A–Z filtert Marken nach Anfangsbuchstabe. Enter sendet die Suche ab.
     Gibt es im Kasten [data-spn2-results] (snippets/sp-nav2-presults.liquid), sucht das Feld ab 2 Zeichen zusätzlich Produkte
     über die Shopify Predictive Search (Titel, Hersteller, Typ, Tags/Herstellernummern, SKU) und zeigt sie unter den Kategorien. */
  function filters(box) {
    if (box.dataset.spn2Filter) return;
    box.dataset.spn2Filter = '1';
    var input = box.querySelector('[data-spn2-filter]');
    var form = input ? input.closest('form') : null;
    var res = box.querySelector('[data-spn2-results]');
    var resList = res ? res.querySelector('[data-spn2-results-list]') : null;
    var resAll = res ? res.querySelector('[data-spn2-results-all]') : null;
    var status = box.querySelector('[data-spn2-status]');
    var letter = '', timer = 0, ctrl = null, lastQ = '';
    var prod = { q: '', n: 0, pending: false };
    function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
    function scope() {
      var tab = box.querySelector('[data-spn2-tab]:not([hidden])');
      return tab || box;
    }
    function searchUrl(q) {
      var base = (form && form.getAttribute('action')) || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'search';
      return base + (base.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(q) + '&type=product';
    }
    function sized(src, w) {
      if (!src) return '';
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }
    function setStatus(t) { if (status) status.textContent = t; }
    function run() {
      var q = norm(input ? input.value : '');
      var root = scope(), shown = 0;
      root.querySelectorAll('[data-spn2-item]').forEach(function (li) {
        var t = norm(li.textContent);
        var ok = (!q || t.indexOf(q) !== -1) && (!letter || t.charAt(0) === letter);
        li.hidden = !ok; if (ok) shown++;
      });
      root.querySelectorAll('[data-spn2-group]').forEach(function (g) {
        g.hidden = !g.querySelector('[data-spn2-item]:not([hidden])');
      });
      var active = !!(q || letter);
      box.querySelectorAll('[data-spn2-hide-on-filter]').forEach(function (el) { el.hidden = active; });
      var empty = root.querySelector('[data-spn2-empty]');
      // „Kein Treffer“ erst, wenn weder Kategorien noch Produkte gefunden wurden (und keine Produktsuche mehr läuft)
      var prodOpen = res && prod.q.length >= 2 && (prod.pending || prod.n > 0);
      if (empty) empty.hidden = !(active && shown === 0 && !prodOpen);
    }
    function render(q, items) {
      if (!res || !resList) return;
      resList.textContent = '';
      items.forEach(function (p) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'spn2-pres__r'; a.href = p.url;
        var im = document.createElement('span'); im.className = 'spn2-pres__img';
        var src = p.image || (p.featured_image && p.featured_image.url) || '';
        if (src) {
          var img = document.createElement('img');
          img.src = sized(src, 160); img.alt = ''; img.loading = 'lazy'; img.width = 64; img.height = 64;
          im.appendChild(img);
        }
        var tx = document.createElement('span'); tx.className = 'spn2-pres__t';
        if (p.vendor) { var v = document.createElement('span'); v.className = 'spn2-l spn2-mut'; v.textContent = p.vendor; tx.appendChild(v); }
        var ti = document.createElement('span'); ti.className = 'spn2-b'; ti.textContent = p.title; tx.appendChild(ti);
        a.appendChild(im); a.appendChild(tx); li.appendChild(a); resList.appendChild(li);
      });
      if (resAll) {
        resAll.href = searchUrl(q);
        resAll.textContent = (res.getAttribute('data-t-all') || '{q}').replace('{q}', q);
      }
      res.hidden = items.length === 0;
      var n = items.length;
      setStatus(n === 0 ? res.getAttribute('data-t-zero') : (n === 1 ? res.getAttribute('data-t-one') : (res.getAttribute('data-t-many') || '').replace('{n}', n)));
    }
    function clearProducts() {
      if (ctrl) { ctrl.abort(); ctrl = null; }
      clearTimeout(timer);
      prod.q = ''; prod.n = 0; prod.pending = false; lastQ = '';
      if (res) { res.hidden = true; if (resList) resList.textContent = ''; }
      setStatus('');
    }
    function products() {
      if (!res || !input) return;
      var q = input.value.trim();
      if (q.length < 2) { clearProducts(); return; }
      if (q === lastQ && (prod.pending || prod.q === q)) return;
      lastQ = q;
      if (ctrl) { ctrl.abort(); ctrl = null; }
      clearTimeout(timer);
      prod.q = q; prod.pending = true;
      timer = setTimeout(function () {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        var c = ('AbortController' in window) ? new AbortController() : null;
        ctrl = c;
        fetch(url, c ? { signal: c.signal, headers: { Accept: 'application/json' } } : { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (d) {
            if (ctrl !== c || prod.q !== q) return;
            var items = (d && d.resources && d.resources.results && d.resources.results.products) || [];
            ctrl = null; prod.pending = false; prod.n = items.length;
            render(q, items); run();
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (ctrl !== c) return;
            ctrl = null; prod.pending = false; prod.n = 0;
            if (res) res.hidden = true;
            run();
          });
      }, 250);
    }
    /* Pfeiltasten: vom Feld in die Treffer (Kategorien, dann Produkte) und zurück */
    function links() {
      var out = [];
      scope().querySelectorAll('[data-spn2-item]:not([hidden]) a').forEach(function (a) { if (!a.closest('[hidden]')) out.push(a); });
      if (res && !res.hidden) res.querySelectorAll('a').forEach(function (a) { out.push(a); });
      return out;
    }
    box.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      if (!input || !input.value.trim()) return;
      var l = links(); if (!l.length) return;
      var i = e.target === input ? -1 : l.indexOf(e.target);
      if (e.target !== input && i === -1) return;
      e.preventDefault();
      if (e.key === 'ArrowDown') { (l[i + 1] || l[l.length - 1]).focus(); }
      else if (i <= 0) { input.focus(); }
      else { l[i - 1].focus(); }
    });
    if (input) input.addEventListener('input', function () { products(); run(); });
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-spn2-letter]');
      if (b) {
        e.preventDefault();
        letter = norm(b.getAttribute('data-spn2-letter'));
        box.querySelectorAll('[data-spn2-letter]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        run(); return;
      }
      if (e.target.closest('[data-spn2-tab-btn]')) setTimeout(run, 0);
    });
  }
  function mobile(m) {
    if (m.dataset.spn2Ready) return;
    m.dataset.spn2Ready = '1';
    var l1 = m.querySelector('[data-spn2m-l1]');
    function closeAll() {
      m.querySelectorAll('[data-spn2m-l2]').forEach(function (p) { p.classList.remove('is-in'); p.hidden = true; });
      m.querySelectorAll('[data-spn2m-go]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (l1) l1.inert = false;
    }
    m.addEventListener('click', function (e) {
      var go = e.target.closest('[data-spn2m-go]');
      if (go) {
        var p = m.querySelector('[data-spn2m-l2="' + go.getAttribute('data-spn2m-go') + '"]');
        if (!p) return;
        p.hidden = false; go.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(function () { p.classList.add('is-in'); });
        if (l1) l1.inert = true;
        var back = p.querySelector('[data-spn2m-back]'); if (back) setTimeout(function () { back.focus({ preventScroll: true }); }, 50);
        return;
      }
      var bk = e.target.closest('[data-spn2m-back]');
      if (bk) {
        var pp = bk.closest('[data-spn2m-l2]'); if (!pp) return;
        pp.classList.remove('is-in'); if (l1) l1.inert = false;
        var id = pp.getAttribute('data-spn2m-l2'), opener = m.querySelector('[data-spn2m-go="' + id + '"]');
        setTimeout(function () { pp.hidden = true; if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); } }, 220);
      }
    });
    var drawer = m.closest('navigation-drawer');
    if (drawer) {
      drawer.addEventListener('dialog:after-hide', closeAll);
      if (!drawer.dataset.spn2DialogFix) {
        drawer.dataset.spn2DialogFix = '1';
        // anderes Dialog-Element (Suche, Warenkorb) geöffnet: Menü schließen
        drawer.addEventListener('click', function (e) {
          var op = e.target.closest('[aria-controls]'); if (!op) return;
          var t = document.getElementById(op.getAttribute('aria-controls'));
          if (!t || drawer.contains(t)) return;
          if (typeof drawer.hide === 'function') drawer.hide(); else drawer.removeAttribute('open');
        });
      }
    }
  }
  /* Board 266: Jacken-Akkordeon (Mobil), Branchenband „Handwerk & Bau“ (Desktop + Mobil, Hover/Klick, Esc schließt),
     Westen-Kachel folgt dem Umschalter Bedrucken|Besticken. Markup: snippets/sp-nav2-split.liquid */
  function board266() {
    if (document.documentElement.dataset.spn2a266) return;
    document.documentElement.dataset.spn2a266 = '1';
    function reset(inn) { if (inn) { inn.style.maxHeight = ''; inn.style.overflowY = ''; } }
    /* Band nie hart vom Bildschirmrand abschneiden: Panel-Inhalt wird scrollbar und das Band rückt ins Bild */
    function fit(br) {
      var inn = br.closest('.spn2__in');
      if (!inn) { if (br.scrollIntoView) br.scrollIntoView({ block: 'nearest' }); return; }
      reset(inn);
      if (br.hidden) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = inn.getBoundingClientRect();
      if (r.bottom > vh && r.top < vh) {
        inn.style.maxHeight = Math.max(240, Math.floor(vh - r.top)) + 'px';
        inn.style.overflowY = 'auto';
        var b = br.getBoundingClientRect(), ir = inn.getBoundingClientRect();
        if (b.bottom > ir.bottom) inn.scrollTop += Math.ceil(b.bottom - ir.bottom);
      }
    }
    function band(btn, open) {
      var br = document.getElementById(btn.getAttribute('aria-controls'));
      if (!br) return;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      br.hidden = !open;
      if (open) fit(br); else reset(br.closest('.spn2__in'));
    }
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var a = t.closest('[data-spn2a-acc]');
      if (a) {
        e.preventDefault();
        var l = document.getElementById(a.getAttribute('aria-controls')), o = a.getAttribute('aria-expanded') !== 'true';
        a.setAttribute('aria-expanded', o ? 'true' : 'false');
        if (l) l.hidden = !o;
        return;
      }
      var b = t.closest('[data-spn2a-br-btn]');
      if (b) {
        e.preventDefault();
        var isOpen = b.getAttribute('aria-expanded') === 'true';
        // gerade per Hover geöffnet: der folgende Klick soll nicht sofort wieder schließen
        if (isOpen && Date.now() - (+b.dataset.hoverAt || 0) < 600) return;
        band(b, !isOpen);
        return;
      }
      var tb = t.closest('[data-spn2-tab-btn]');
      if (tb) {
        var key = tb.getAttribute('data-spn2-tab-btn'), box = tb.closest('.spn2__in, .spn2m__body');
        if (box) box.querySelectorAll('[data-spn2a-alt]').forEach(function (x) { var h = x.getAttribute('data-' + key); if (h) x.setAttribute('href', h); });
      }
    });
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse' || !e.target.closest) return;
      var b = e.target.closest('[data-spn2a-br-btn]');
      if (!b || !b.closest('.spn2') || b.getAttribute('aria-expanded') === 'true') return;
      clearTimeout(b._spn2t);
      b._spn2t = setTimeout(function () {
        if (!b.matches(':hover') || b.getAttribute('aria-expanded') === 'true') return;
        b.dataset.hoverAt = String(Date.now());
        band(b, true);
      }, 120);
    });
    var escDone = false;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var t = e.target, btn = null;
      if (!t || !t.closest) return;
      var br = t.closest('[data-spn2a-br]');
      if (br && !br.hidden) btn = document.querySelector('[aria-controls="' + br.id + '"]');
      if (!btn) { var x = t.closest('[data-spn2a-br-btn]'); if (x && x.getAttribute('aria-expanded') === 'true') btn = x; }
      if (!btn) return;
      e.stopPropagation(); e.preventDefault(); escDone = true;
      band(btn, false); btn.focus({ preventScroll: true });
    }, true);
    document.addEventListener('keyup', function (e) {
      if (escDone && (e.key === 'Escape' || e.key === 'Esc')) { escDone = false; e.stopPropagation(); }
    }, true);
    /* Panel wieder geöffnet oder Fenster geändert: offenes Band neu einpassen */
    function refit() { document.querySelectorAll('.spn2 [data-spn2a-br]:not([hidden])').forEach(fit); }
    document.addEventListener('toggle', function (e) { if (e.target && e.target.classList && e.target.classList.contains('spn2-dd') && e.target.open) requestAnimationFrame(refit); }, true);
    var rt = 0;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(refit, 150); });
  }
  function boot() {
    board266();
    document.querySelectorAll('.spn2-nav, [data-spn2m]').forEach(function (r) { if (!r.dataset.spn2Tabs) { r.dataset.spn2Tabs = '1'; tabs(r); } });
    document.querySelectorAll('[data-spn2m]').forEach(mobile);
    document.querySelectorAll('[data-spn2-filterbox]').forEach(filters);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();